import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["editor"]

  connect() {
    this.element.addEventListener("trix-attachment-add", this.handleAttachment)
  }

  disconnect() {
    this.element.removeEventListener("trix-attachment-add", this.handleAttachment)
  }

  handleAttachment = (event) => {
    const attachment = event.attachment
    if (!attachment.file) return

    const upload = new DirectUpload(
      attachment.file,
      "/rails/active_storage/direct_uploads"
    )

    upload.create((error, blob) => {
      if (error) {
        console.error("Direct upload failed:", error)
        attachment.remove()
        return
      }

      const url = `${window.location.origin}/rails/active_storage/blobs/redirect/${blob.signed_id}/${encodeURIComponent(blob.filename)}`
      attachment.setAttributes({ url, href: url })
    })
  }
}
